import {
  AutoCompleteMulti,
  ISelectType,
  useDebounce,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import {
  ChangeEvent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { internalProcedureList } from "../../../../../../../services/internalProcedure.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.appointmentArrival.";

export const Procedures = memo(() => {
  const { t } = useTranslation();

  const [optionsProcedures, setProcedures] = useState<ISelectType[]>([]);

  const [searchByProcedures, setSearchByProcedures] = useState("");

  const { sendRequest: proceduresRequest } = useFetch(internalProcedureList);

  const searchQuery = useDebounce(searchByProcedures, 500);

  const paramsProcedure = useMemo(() => {
    return {
      SearchBy: searchQuery,
      EnableCode: true,
    };
  }, [searchQuery]);

  const procedureSearchBy = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      setSearchByProcedures(event.target.value.trim());
    },
    [],
  );

  const fetchProcedures = useCallback(async () => {
    if (paramsProcedure.SearchBy.length < 3) {
      setProcedures((prev) => (prev.length > 0 ? [] : prev));
      return;
    }

    const { data, success } = await proceduresRequest(paramsProcedure);
    if (data && success) {
      setProcedures(
        data.map((d) => ({
          id: d.identifier.toString(),
          name: d.procedureExamName,
        })),
      );
    }
  }, [paramsProcedure, proceduresRequest]);

  useEffect(() => {
    fetchProcedures();
  }, [fetchProcedures]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        name="procedures"
        size="small"
        value={searchByProcedures}
        options={optionsProcedures}
        onChange={procedureSearchBy}
        label={t(translationPath + "internal_procedures")}
        getOptionLabel={(option) => option.name}
        fullWidth
        keepOpenOnSelect
      />

      <Typography variant="caption" color="text.secondary" sx={{ mx: 3 }}>
        {t(translationPath + "procedure_caption")}
      </Typography>
    </Grid>
  );
});
